import { t } from '@lingui/core/macro'

import { getFilenameFromPath, makeAbsolute } from '@jotta/utils/pathUtils'

/**
 * Get translated folder names for top level paths
 * Returns the file name portion of the path if no translation is found
 * @param path Grpc file api path
 * @returns
 */
export function getTranslatedFilenameFromApiPath(
  path: string,
  fallback = getFilenameFromPath(path),
) {
  switch (makeAbsolute(path).toLocaleLowerCase()) {
    case '/archive':
      return t`Archive`
    case '/backup':
      return t`Backup`
    case '/contacts':
      return t`Contacts`
    case '/photos':
      return t`Photo Timeline Uploads`
    case '/shared':
      return t`Shared Files`
    case '/sync':
      return t`Sync`
    case '/trash':
      return t`Trash`
    default:
      return fallback
  }
}

// Some folders such as "contacts" in backups should be translated
export function getTranslatedFilenameFromPathItem(pathItem: {
  path: string
  name: string
}) {
  return getTranslatedFilenameFromApiPath(pathItem.path || '', pathItem.name)
}
